import * as RE from 'helpers/ramda-ext'
import { PARTICIPANTS_CATEGORIES } from 'constants/participants'
import { ParticipantsBirthdates } from 'types/typescript'
import { GetParticipantsBirthdates } from './types/getParticipantsBirthdates.types'

export const getParticipantsBirthdates: GetParticipantsBirthdates = (
  participants
) => (
  participants && PARTICIPANTS_CATEGORIES.reduce<ParticipantsBirthdates>((participantsBirthdates, category) => ({
    ...participantsBirthdates,
    [category]: RE.limitTo(
      participants[category].number,
      participants[category].birthdates
    )
  }), { adults: [], babies: [], children: [] }) /* DEFAULT_PARTICIPANTS_BIRTHDATES */
)
